import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup } from 'reactstrap'
import ProductionStatus from "../../SingleAction/ProductionStatus"
import { ReactComponent as IconFailedDesign } from "../../../../assets/icon/icon-failedDesign.svg"
import TagRequestUpdate from "../../SingleAction/TagRequestUpdate"
import { getLocalData } from "../../../../services/StorageServices"
import { parseJwt } from "../../../../share/parseToken"
import { Tooltip, Dropdown, Menu } from 'antd'
import { TagOutlined } from '@ant-design/icons'
import { ReactComponent as IconGenLabelCustomWHL } from "../../../../assets/icon/icon-barcode-custom-whl-1.svg"
import ResendTikTokModal from './ResendTikTokModal'
import ModalFBAInfo from './ModalFBAInfo'
import { mappingLineShip } from '../ParentRow'

class ParentActionCol extends React.PureComponent {
    state = {
        showResendTikTokModal: false,
        showFBAInfoModal: false
    }

    _handleShowModal = (field) => {
        this.setState({
            [field]: true
        })
    }

    _handleCloseModal = (field) => {
        this.setState({
            [field]: false
        })
    }

    _showSubMenu = () => {
        return (
            <Menu style={{ width: '180px' }}>
                <Menu.Item onClick={() => this._handleShowModal('showResendTikTokModal')}>Resend TikTok</Menu.Item>
            </Menu>
        )
    }

    render() {
        const {
            production_status,
            item,
            reloadItems,
            handleClickEditProduct,
            handleClickEdit,
            renderIconGenerate,
            productStatus,
            handleClickMarkFaileDesign,
            tags = [],
            itemsRequest,
            onChangeFilterTag,
            handleClickGenLabelCustomWHL,
            orderLabelDetails = {},
            handleClickReturn,
            orderType,
        } = this.props
        const displayField = productStatus === 'cancelled' ? 'notDisableCancel' : ''
        const barcodeNumber = `#${item.barcodeNumber}_${item.pos}`
        const itemRequest = itemsRequest.filter(item => item.fac_barcode_number === barcodeNumber)
        const listProductStatusRequestUpdate = ['false_design', 'in_production', 'pending', 'on-hold']
        const token = getLocalData('accessToken')
        const user = token !== '' && parseJwt(token).permissions ? parseJwt(token).permissions : {}
        const roles = token !== '' && parseJwt(token).roles ? parseJwt(token).roles : []
        const rolesArr = roles.map(role => {
            return role.name
        })
        const { gen_time = 0 } = item || {}
        const canResendTitok = Array.isArray(tags) && tags.includes('shipbytiktok') && !tags.includes('tiktok_info_sent') && gen_time > 1
        const { showResendTikTokModal, showFBAInfoModal } = this.state
        const lineShip = mappingLineShip(orderLabelDetails && orderLabelDetails.shipping_carrier) || {}

        const hasLabelId = item.meta && item.meta.label && (/^[0-9a-fA-F]{24}$/.test(item.meta.label.id || '') ? item.meta.label.id : item.meta.label._id)

        return (
            <div className={`notDisableCancel Action ${displayField}`}>
                <ButtonGroup>
                    {
                        production_status !== 'labelled' &&
                        <Tooltip title="Edit Item">
                            <button
                                type="button"
                                className="btn-icon mr-2 mb-2"
                                onClick={handleClickEditProduct}
                            >
                                <i className="icon-pencil5 text-warning" aria-hidden="true" />
                            </button>
                        </Tooltip>
                    }

                    {(listProductStatusRequestUpdate.includes(production_status) && (user.hasOwnProperty('request_update') || user.hasOwnProperty('fac_request_update'))) &&
                        <Tooltip title="Update Design">
                            <button
                                type="button"
                                className="btn-icon mr-2 mb-2"
                                onClick={handleClickMarkFaileDesign}
                            >
                                <IconFailedDesign width={20} height={15} />
                            </button>
                        </Tooltip>
                    }

                    {
                        production_status !== 'labelled' &&
                        <>
                            <span>
                                {!hasLabelId && !(tags.includes('ship_VP') && tags.includes('shipped_vhmc') && !tags.includes('returned')) && (
                                    <Tooltip title="Edit Address">
                                        <i className='icon-pencil text-success mr-2 mb-2 cursor-pointer' onClick={handleClickEdit} />
                                    </Tooltip>
                                )}

                                {(production_status !== 'cancelled' && production_status !== 'cancel-ship' && !tags.includes('combo_fac')) && renderIconGenerate()}
                            </span>
                            {!tags.includes('combo_fac') &&
                                <Tooltip placement="topRight" title={`Generate label ${lineShip.name ? `${lineShip.name} ` : ''}by custom data`}>
                                    <IconGenLabelCustomWHL
                                        className="mr-1 mb-2 cursor-pointer"
                                        width={24}
                                        height={24}
                                        onClick={handleClickGenLabelCustomWHL}
                                    />
                                </Tooltip>
                            }
                        </>
                    }

                    {orderType && orderType === 'FBA' &&
                        <Tooltip title="Edit Label/Fn sku">
                            <TagOutlined
                                className="mr-2 mb-2 cursor-pointer text-success"
                                style={{ fontSize: 24, width: 24, height: 24 }}
                                onClick={() => this._handleShowModal('showFBAInfoModal')}
                            />
                        </Tooltip>
                    }

                    {tags.includes('shipped_vhmc') && !tags.includes('returned') &&
                        <Tooltip title="Return">
                            <button
                                type="button"
                                className="btn-icon mr-2 mb-2"
                                onClick={() => handleClickReturn(item)}
                            >
                                <i className="icon-reset text-danger" aria-hidden="true" />
                            </button>
                        </Tooltip>
                    }


                    {canResendTitok &&
                        <div className='MoreActions Icon'>
                            <Dropdown overlay={this._showSubMenu} trigger={['click']}>
                                <span className='Icon'><i className='fa fa-ellipsis-h text-dark mr-1 mb-2 cursor-pointer' /></span>
                            </Dropdown>
                        </div>
                    }
                </ButtonGroup>
                <div className="Bottom d-flex mt-2">
                    <ProductionStatus reloadItems={reloadItems} item={item} roles={rolesArr} />
                </div>

                {
                    Array.isArray(tags) && tags.length > 0 &&
                    <div className="TagRequest mt-2">
                        {
                            tags.map((tag, index) => {
                                const itemRequestCurrent = itemRequest[index] || {}
                                return <TagRequestUpdate
                                    tag={tag === 'is_set' ? 'Set' : tag}
                                    item={item}
                                    key={`${tag}_${index}`}
                                    itemRequest={itemRequestCurrent.content || ''}
                                    onChangeFilterTag={onChangeFilterTag}
                                />
                            })
                        }
                    </div>
                }
                <ResendTikTokModal
                    visible={showResendTikTokModal}
                    onClose={() => this._handleCloseModal('showResendTikTokModal')}
                    item={item}
                    reloadItems={reloadItems}
                />
                <ModalFBAInfo
                    visible={showFBAInfoModal}
                    onClose={() => this._handleCloseModal('showFBAInfoModal')}
                    item={item}
                    reloadItems={reloadItems}
                />
            </div>
        )
    }
}

ParentActionCol.propTypes = {
    productStatus: PropTypes.string,
    production_status: PropTypes.string,
    item: PropTypes.object.isRequired,
    reloadItems: PropTypes.func.isRequired,
    handleClickEdit: PropTypes.func.isRequired,
    handleClickEditProduct: PropTypes.func.isRequired,
    renderIconGenerate: PropTypes.func.isRequired,
    tags: PropTypes.array,
    handleClickMarkFaileDesign: PropTypes.func,
    itemsRequest: PropTypes.any,
    onChangeFilterTag: PropTypes.func,
    handleClickGenLabelCustomWHL: PropTypes.func,
    handleClickReturn: PropTypes.func,
    orderType: PropTypes.string,
}

export default ParentActionCol
